import React from 'react'
import { Modal, Box } from '@material-ui/core';
import { Button } from 'reactstrap'
import '../Shared/Css/VideoList.css'

function VideoDetail(props) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '50%',
    width: 'auto',
    // height: '58%',
    // width: '50%',
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderColor: "primary.light",
    background: "black",
    backgroundSize: 'cover',
    overflow: 'hidden',
    aspectRatio: 16 / 9,
    /* objectFit: 'cover', */ /* 종횡비 가득차게 */
    // boxShadow: 24,
  };

  return (
    <div style={{ objectFit: 'cover' }}>
      <Modal open={props.videoModal}>
        <Box style={style} className='bothsize'>
          <Button
            style={{
              position: 'absolute',
              background: '#009688',
              color: 'white',
              height: '2rem',
              width: '5rem',
              fontSize: '0.85rem',
              margin: 20,
              right: '0',
              float: "center",
              zIndex: '1'  //z-index 겹침부분인덱스 기본갑은 0 이다
            }}
            onClick={() => {
              props.setVideoModal(false)
            }}
          >
            나가기
          </Button>
          <video
            style={{ margin: 'auto', display: 'block' }}
            controls
            preload="auto"
            autoPlay
            width="100%"
            height="100%"
            data-setup="{}"
          >
            <source src={process.env.PUBLIC_URL + "/videolist/bongsunga_p" + props.videoId + ".mp4"} />
          </video>
        </Box>
      </Modal>
    </div>
  )
}

export default VideoDetail